import { isValid, parseISO } from 'date-fns';
import isObject from 'lodash/isObject';
import _toPlainObject from 'lodash/toPlainObject';
import SuperJSON from 'superjson';

type SuperJSONResult = ReturnType<SuperJSON['serialize']>;
SuperJSON.registerCustom<Date, string>(
    {
        isApplicable: (v): v is Date => v instanceof Date,
        serialize: (v) => v.toJSON()?.replace(/Z$/, '') || '',
        deserialize: (v) => parseISO(v),
    },
    'JUCY.Date'
);

const cleanse = <T>(value: T) => {
    if (value) {
        if (Array.isArray(value)) {
            value = value.map((v) => cleanse(v)) as never;
        } else if (!isObject(value)) {
            return value;
        } else {
            value = (_toPlainObject(value) || null) as T;
            if (isObject(value)) {
                for (const [prop, propValue] of Object.entries(value) as [keyof T, unknown][]) {
                    if (propValue instanceof Date) {
                        value[prop] = (isValid(propValue) ? propValue : null) as never;
                    } else if (isObject(propValue)) {
                        value[prop] = cleanse(propValue) as never;
                    } else if (Array.isArray(propValue)) {
                        value[prop] = propValue.map((v) => cleanse(v)) as never;
                    } else if (propValue === undefined) {
                        delete value[prop];
                    }
                }
            }
        }
    }
    return value;
};

const isSuperJSONResult = (value: unknown): value is SuperJSONResult => (value as SuperJSONResult)?.json !== undefined;

class Serializer {
    serialize<T>(data: T): T {
        return SuperJSON.serialize(cleanse(data)) as unknown as T;
    }

    deserialize<T>(data: T): T {
        return isSuperJSONResult(data) ? SuperJSON.deserialize(data) : data;
    }
}

const serializer = new Serializer();
export default serializer;
